import axios from 'axios';
import { AppConsts } from '../enums/AppConsts';

const baseUrl = process.env.BASE_SERVER_ADDRESS;
const getToken = () => localStorage.getItem(AppConsts.AccessToken);
const getHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const GetLandingPageById = async (externalId: string) => {
  return await axios.get(`${baseUrl}/LandingPage/Get/${externalId}`, getHeaders());
};
